import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TextCustomFieldConfig, SharedModule, FormInputComponent, DataService } from '@vendure/admin-ui/core';

@Component({
    selector: 'vdr-available-months-form',
    templateUrl: './available-months-form.component.html',
    styleUrls: ['./available-months-form.component.scss'],
    standalone: true,
    imports: [SharedModule],
})
export class AvailableMonthsFormComponent implements FormInputComponent<TextCustomFieldConfig> {
    readonly: boolean;
    config: TextCustomFieldConfig;
    formControl: FormControl;

    defaultValues = {
        month: 'all',
        openingTime: '00:00',
        closingTime: '23:59',
    };

    constructor(
        private dataService: DataService,
        private route: ActivatedRoute,
    ) {}

    ngOnInit() {
        if (this.formControl.value) {
            this.defaultValues = JSON.parse(this.formControl.value);
        } else {
            this.formControl.setValue(JSON.stringify(this.defaultValues));
        }
    }

    onValueChange(event: Event, type: 'month' | 'openingTime' | 'closingTime') {
        const newValue = (event.target as HTMLInputElement).value;
        this.defaultValues[type] = newValue;
        this.formControl.setValue(JSON.stringify(this.defaultValues));
    }
}
